module.exports = __webpack_public_path__ + "static/media/mark.aab0d11c.svg";